import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-be698626")

_pushScopeId("data-v-be698626")
const _hoisted_1 = { class: "flex items-center gap-4 flex-1 min-w-0" }
const _hoisted_2 = { class: "w-28 flex-shrink-0 text-sm font-semibold text-gray-lp-300" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_4 = { class: "flex items-center gap-3 flex-shrink-0 relative" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text-sm font-bold" }, "+", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TimeSlotChip = _resolveComponent("TimeSlotChip")!
  const _component_PickupTimePopover = _resolveComponent("PickupTimePopover")!

  return (_openBlock(), _createBlock("div", {
    "data-testid": `pickup-schedule-config-special-date-row-${_ctx.date}`,
    class: ["flex items-center justify-between gap-4 py-3 border-b border-gray-lp-400 last:border-none", { 'opacity-50 pointer-events-none': _ctx.disabled }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.dateLabel), 1),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedSlots, (slot, index) => {
          return (_openBlock(), _createBlock(_component_TimeSlotChip, {
            key: `${slot.start}-${slot.end}-${index}`,
            "time-slot": slot,
            disabled: _ctx.disabled,
            "data-testid": `pickup-schedule-config-time-chip-${_ctx.date}-${index}`,
            onRemove: ($event: any) => (_ctx.onRemoveSlot(slot))
          }, null, 8, ["time-slot", "disabled", "data-testid", "onRemove"]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("button", {
        type: "button",
        "data-testid": `button-add-time-${_ctx.date}`,
        class: ["inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-lg border transition-all", 
          _ctx.isMaxSlots
            ? 'border-gray-lp-400 text-gray-lp-500 bg-gray-lp-1000 cursor-not-allowed'
            : 'special-action special-action-border hover:bg-red-50'
        ],
        disabled: _ctx.isMaxSlots || _ctx.disabled,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePopover && _ctx.togglePopover(...args)))
      }, [
        _hoisted_5,
        _createVNode("span", null, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.addTime") || "Tambah jam"), 1)
      ], 10, ["data-testid", "disabled"]),
      _createVNode(_component_PickupTimePopover, {
        open: _ctx.isPopoverOpen,
        "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPopoverOpen = $event)),
        day: _ctx.date,
        "existing-slots": _ctx.slots,
        "slot-start-hour": _ctx.slotStartHour,
        "slot-end-hour": _ctx.slotEndHour,
        "slot-interval-minutes": _ctx.slotIntervalMinutes,
        onConfirm: _ctx.onAddSlotConfirm
      }, null, 8, ["open", "day", "existing-slots", "slot-start-hour", "slot-end-hour", "slot-interval-minutes", "onConfirm"]),
      _createVNode("button", {
        type: "button",
        "data-testid": `pickup-schedule-config-button-delete-date-${_ctx.date}`,
        class: "p-1 text-red-500 hover:text-red-700 transition-colors focus:outline-none",
        disabled: _ctx.disabled,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('remove-date')))
      }, [
        _hoisted_6
      ], 8, ["data-testid", "disabled"])
    ])
  ], 10, ["data-testid"]))
})